<mat-dialog-content class="new-address-dialog">
    <!-- =====================================================
         HEADER
         ===================================================== -->
    <header class="new-address-header">
        <div class="new-address-heading">
            <span class="new-address-eyebrow">
                ENVÍO A DOMICILIO
            </span>
            <h2>
                Datos de dirección
            </h2>
        </div>
        <button class="new-address-close" type="button" aria-label="Cerrar" (click)="close()">
            <mat-icon>
                close
            </mat-icon>
        </button>
    </header>
    <!-- =====================================================
         BODY
         ===================================================== -->
    <div class="new-address-body">
        <p class="new-address-description">
            Completa los datos y marca en el mapa la ubicación exacta
            de tu domicilio.
        </p>
        <!-- =================================================
             FORMULARIO
             ================================================= -->
        <form [formGroup]="addressForm" (ngSubmit)="addAddress()" novalidate>
            <div class="form-grid">
                <!-- RECIBE -->
                <div class="form-field form-field--wide">
                    <label>
                        ¿QUIÉN RECIBE?
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="receiving_name" type="text"
                            placeholder="Nombre de quien recibe">
                    </mat-form-field>
                    <mat-error *ngIf="receiving_name?.invalid &&
                        (receiving_name?.dirty || receiving_name?.touched)">
                        {{ getErrorMessage('receiving_name') }}
                    </mat-error>
                </div>
                <!-- CALLE -->
                <div class="form-field">
                    <label>
                        CALLE
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="street" type="text" placeholder="Nombre de la calle">
                    </mat-form-field>
                    <mat-error *ngIf="street?.invalid &&
                        (street?.dirty || street?.touched)">
                        {{ getErrorMessage('street') }}
                    </mat-error>
                </div>
                <!-- NUMERO -->
                <div class="form-field">
                    <label>
                        NÚMERO EXTERIOR
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="ext_number" type="text" placeholder="Número exterior">
                    </mat-form-field>
                    <mat-error *ngIf="ext_number?.invalid &&
                        (ext_number?.dirty || ext_number?.touched)">
                        {{ getErrorMessage('ext_number') }}
                    </mat-error>
                </div>
                <!-- CÓDIGO POSTAL -->
                <div class="form-field">
                    <label>
                        CÓDIGO POSTAL
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="zip_code" type="text" maxlength="5" inputmode="numeric"
                            placeholder="Código postal" (input)="searchDataZipCode()">
                    </mat-form-field>
                    <mat-error *ngIf="zip_code?.invalid &&
                        (zip_code?.dirty || zip_code?.touched)">
                        {{ getErrorMessage('zip_code') }}
                    </mat-error>
                </div>
                <!-- COLONIA -->
                <div class="form-field">
                    <label>
                        COLONIA
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <mat-select formControlName="locality_id" placeholder="Selecciona una colonia"
                            (selectionChange)="onSelectionLocality($event)">
                            <mat-option value="">
                                Selecciona una colonia
                            </mat-option>
                            <mat-option *ngFor="let localitie of dataLocalities | async" [value]="localitie.id">
                                {{ localitie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- MUNICIPIO -->
                <div class="form-field">
                    <label>
                        MUNICIPIO
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="municipality" type="text" placeholder="Municipio" readonly>
                    </mat-form-field>
                </div>
                <!-- ESTADO -->
                <div class="form-field">
                    <label>
                        ESTADO
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="state" type="text" placeholder="Estado" readonly>
                    </mat-form-field>
                </div>
                <!-- TELÉFONO -->
                <div class="form-field">
                    <label>
                        TELÉFONO
                    </label>
                    <mat-form-field class="address-input" appearance="outline">
                        <input matInput formControlName="phone" type="number" placeholder="Teléfono">
                    </mat-form-field>
                    <mat-error *ngIf="phone?.invalid &&
                        (phone?.dirty || phone?.touched)">
                        {{ getErrorMessage('phone') }}
                    </mat-error>
                </div>
                <!-- REFERENCIAS -->
                <div class="form-field form-field--wide">
                    <label>
                        REFERENCIAS
                    </label>
                    <mat-form-field class="address-input address-textarea" appearance="outline">
                        <textarea matInput formControlName="references" rows="2"
                            placeholder="Ej. casa con portón negro, frente al parque...">
                        </textarea>
                    </mat-form-field>
                    <mat-error *ngIf="references?.invalid &&
                        (references?.dirty || references?.touched)">
                        {{ getErrorMessage('references') }}
                    </mat-error>
                </div>
            </div>
            <!-- =================================================
                 MAPA
                 ================================================= -->
            <section class="map-section">
                <div class="map-section-header">
                    <div>
                        <span class="map-eyebrow">
                            UBICACIÓN
                        </span>
                        <h3>
                            Ubicación en el mapa
                        </h3>
                        <p>
                            Da clic o arrastra el pin hasta la ubicación exacta.
                        </p>
                    </div>
                    <div class="map-section-icon">
                        <mat-icon>
                            location_on
                        </mat-icon>
                    </div>
                </div>
                <div class="map-container">
                    <agm-map [latitude]="map_lat" [longitude]="map_lng" [zoom]="zoom"
                        (mapClick)="onMapClickEvent($event)">
                        <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                            (dragEnd)="markerDragEnd($event)" *ngIf="latitude != 0 && longitude != 0">
                            <agm-info-window [isOpen]="true">
                                <div class="map-info-window">
                                    <strong>
                                        Tu dirección
                                    </strong>
                                    <div class="map-info-address">
                                        {{ direccionPin || 'Obteniendo dirección...' }}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </agm-map>
                </div>
            </section>
            <!-- =================================================
                 CAMPOS TÉCNICOS
                 ================================================= -->
            <input type="hidden" formControlName="municipality_id">
            <input type="hidden" formControlName="state_id">
            <input type="hidden" formControlName="lat">
            <input type="hidden" formControlName="lng">
            <!-- =================================================
                 ACCIONES
                 ================================================= -->
            <div class="new-address-actions">
                <button class="cancel-button" mat-button type="button" (click)="close()">
                    Cancelar
                </button>
                <button class="save-address-button" mat-raised-button type="submit" [disabled]="!addressForm.valid">
                    Guardar dirección
                </button>
            </div>
        </form>
    </div>
</mat-dialog-content>